import {h} from 'preact';
import {Route, Redirect} from 'react-router-dom';

const ProtectedRoute = ( {component: Component, authorized, redirectTo = '/', ...rest} ) => {
    return (
        <Route {...rest} render={ props => (
            authorized()
            ? <Component {...props} />
            : <Redirect push to={redirectTo} />
        )} />
    )};

export default ProtectedRoute;